module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A fixed-size container for other components that adds scrolling.</p>\n<p>The ScrollBox can be configured to display styled scrollbars and/or scroll\nindicators/buttons.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;ScrollBox scroll=&quot;horizontal&quot;&gt;\n    &lt;Table&gt;\n        ...\n    &lt;/Table&gt;\n&lt;/ScrollBox&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/ScrollBox/README.md
// module id = 384
// module chunks = 0